export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Magvi"},{"property":"og:title","content":"Magvi — программа, которая создаёт инфографику для маркетплейсов"},{"property":"og:description","content":"В ней можно бесплатно удалить фон, добавить подходящие иконки, настроить шрифты, выбрать готовую инфографику из шаблонов и отредактировать ее."},{"property":"og:url","content":"https://t.magvi.ru"},{"property":"og:locale","content":"ru_RU"},{"property":"og:image","content":"https://t.magvi.ru/og-image.png"},{"property":"og:image:width","content":1104},{"property":"og:image:height","content":630}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"ru-RU"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const vueAppRootContainer = '#__nuxt'